import {Injectable} from '@angular/core';
import {ApiService} from '../../../core/services/api.service';
import {ApiResponse} from '../../../core/shared/classes/api';
import {Observable} from 'rxjs';
import {Unite} from '../classes/unite';

@Injectable()
export class UniteService {

    constructor(private apiService: ApiService) {}

    public fetchUnites(): Observable<ApiResponse> {
        return this.apiService.get('unite/');
    }

    public fetchUnite(id): Observable<ApiResponse> {
        return this.apiService.get(`unite/${id}`);
    }

    public createUnite(data: Unite): Observable<ApiResponse> {
        return this.apiService.post('unite/', JSON.stringify(data));
    }

    public updateUnite(id, data: Unite): Observable<ApiResponse> {
        return this.apiService.put(`unite/${id}`, JSON.stringify(data));
    }

    public deleteUnite(id): Observable<ApiResponse> {
        return this.apiService.delete(`unite/${id}`);
    }
}
